export default "__VITE_ASSET__db82049e__"